import React, { useEffect } from 'react';
import Error from "./Error";
import GlobalContext from "./GlobalContext";
import ResultsList from "./ResultsList";
import { useParams } from "react-router-dom";

function ResultsByCategory(){
  const global = React.useContext(GlobalContext);
  const { categorySlug } = useParams();

  useEffect(() => {
    if (categorySlug && global.state.initialized) {
      global.actions.setCategory([categorySlug]);
    }
  }, [global.state.initialized, categorySlug]);

  if(!global.state.initialized || global.state.error) return false;

  console.log(global.state.names,[categorySlug]);

  return (
    <div className="results">
      <h2>{`Results for ${global.state.names[categorySlug]}`}</h2>
      <Error />
      <ResultsList />
    </div>
  );
}

export default ResultsByCategory;